// packages/validation/src/interactiveAnswers.ts
import { z } from 'zod';

export const interactiveAnswersSchema = z.object({
  messageId: z.string().min(1),
  answers: z
    .array(
      z.object({
        rowId: z.string().min(1),
        value: z.string().min(1),
        makeRule: z.boolean(),
      }),
    )
    .min(1),
});

export type InteractiveAnswersInput = z.infer<typeof interactiveAnswersSchema>;
